import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PriceyardService } from '../../../modules/priceyard/services/priceyard.service';
import { map, takeUntil } from 'rxjs/operators';
import { RepriceListItem } from 'src/app/models/priceyard.model';
import { Subject } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-update-repricer',
  templateUrl: './update-repricer.component.html',
  styleUrls: ['./update-repricer.component.scss']
})
export class UpdateRepricerComponent implements OnInit,OnDestroy {
  actions: any[];
  options;
  private destroy$ = new Subject<void>();
  settingsForm: FormGroup = new FormGroup({
    Prmodel: this.newFormGroup("name", "isActive")
  });
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<UpdateRepricerComponent>,
    private priceyardService: PriceyardService,
  ) {}

  ngOnInit(): void {
    this.getPriceModel();
    this.actions = this.data.actions || [
      { text: "Cancel", buttonStyle: "underline" },
      { text: "Save", spin:false },
    ];
    let setIsActive;  
    this.data.selectedRows?.length > 1 ? setIsActive = false: setIsActive = this.data.selectedRows[0].PricingOn;
    this.settingsForm.get("Prmodel").patchValue({ isActive: setIsActive }, { emitEvent: false, onlySelf: true });
  }

  newFormGroup(value, isOn) {
    return new FormGroup({
      [value]: new FormControl(""),
      [isOn]: new FormControl(""),
    });
  }

  dialogAction(e) {
    const modelName = this.options?.find((option) =>
        option.modelId === Number(this.settingsForm.get("Prmodel").value["name"])
    )?.name;
    const pricingOn = this.settingsForm.get("Prmodel").value.isActive;
    if (e === "Save") {
      this.actions[1].spin = true;
      this.data.callBackFn(this.dialogRef,modelName,pricingOn);
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close();
  }

  getPriceModel(){
    this.priceyardService
    .GetPriceModel()
    .pipe(
      takeUntil(this.destroy$),
      map((models: any[]) =>
        models.filter(
          (model: RepriceListItem) =>
            model.marketPlace === this.data.selectedRows[0].AccountType
        )
      )
    )
    .subscribe((e) => {
      this.options = e;
      if (this.data.selectedRows.length == 1 && this.data.selectedRows[0].PriceModelName) {
        const repricingModal = this.options.find(
          (res) => res.name === this.data.selectedRows[0].PriceModelName
        );
        if (repricingModal) {
          this.settingsForm.get("Prmodel").patchValue({ name: repricingModal.modelId }, { emitEvent: false, onlySelf: true });
        }
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
